// extracted by mini-css-extract-plugin
module.exports = {"navigation-stepper":"NavigationStepper_navigation-stepper__3GwTG"};